<div class="common-placeholder-container">
    <h1></h1>
    <h4></h4>
    <div class="data"></div>
</div>